export const menuItems = {
  menu: {
    "@attributes": {
      name: "system",
      txtid: "lng_button_system"
    },
    submenu: [
      {
        "@attributes": {
          name: "menu1",
          txtid: "lng_app_settings"
        },
        field: [
          {
            "@attributes": {
              txtid: "lng_version_settings",
              type: "simpleText"
            }
          },
          {
            "@attributes": {
              txtid: "lng_language_settings",
              type: "langModal"
            }
          }
        ]
      },
      {
        "@attributes": {
          name: "menu2",
          txtid: "lng_discovery_settings"
        },
        field: [
          {
            "@attributes": {
              txtid: "lng_current_version",
              type: "versionText",
              udp: "misc.dl_version"
            }
          },
          {
            "@attributes": {
              fieldset: "access_modes",
              txtid: "lng_nbe_auth_mode_setting",
              type: "dropdown",
              udp: "user.access",
              unittxt: ""
            }
          },
          {
            "@attributes": {
              fieldset: "trueFalse",
              txtid: "lng_setup_91",
              type: "dropdown",
              udp: "misc.expansion_module",
              unittxt: ""
            }
          }
        ]
      }
    ],
    fieldsets: {
      fieldset: [
        {
          "@attributes": {
            name: "yesno",
            type: "nosort"
          },
          field: [
            {
              "@attributes": {
                txtid: "setup_no",
                value: "0"
              }
            },
            {
              "@attributes": {
                txtid: "setup_yes",
                value: "1"
              }
            }
          ]
        },
        {
          "@attributes": {
            name: "trueFalse",
            type: "nosort"
          },
          field: [
            {
              "@attributes": {
                txtid: "lng_yes",
                value: "1"
              }
            },
            {
              "@attributes": {
                txtid: "lng_no",
                value: "0"
              }
            }
          ]
        },
        {
          "@attributes": {
            name: "system_type",
            type: "nosort"
          },
          field: [
            {
              "@attributes": {
                txtid: "lng_rtb",
                value: "0"
              }
            },
            {
              "@attributes": {
                txtid: "lng_blackstar",
                value: "1"
              }
            }
          ]
        },
        {
          "@attributes": {
            name: "access_modes",
            type: "nosort"
          },
          field: [
            {
              "@attributes": {
                txtid: "lng_level_0",
                value: "user"
              }
            },
            {
              "@attributes": {
                txtid: "lng_level_1",
                value: "smith"
              }
            },
            {
              "@attributes": {
                txtid: "lng_level_2",
                value: "nbe"
              }
            }
          ]
        }
      ]
    }
  }
};
